// Text widths for laying out SVG text (an SVG <text> cannot wrap or size a box around itself). Measured once with a 2-D
// canvas at 100 px and cached; the result is in EM, so a width in any unit is `measureEm(text) * fontSize`. Where a
// canvas is not available (tests, SSR) a per-character estimate is used, so layout never throws.

export const SANS = "system-ui, 'Segoe UI', Arial, sans-serif";
export const MONO = "ui-monospace, Menlo, Consolas, monospace";

const cache = new Map();
let ctx;
const context = () => {
  if (ctx !== undefined) return ctx;
  try { ctx = typeof document !== "undefined" ? document.createElement("canvas").getContext("2d") : null; } catch { ctx = null; }
  return ctx || (ctx = null);
};

export function measureEm(text, { bold = false, mono = false } = {}) {
  const s = String(text ?? "");
  const key = `${bold ? "b" : "n"}${mono ? "m" : "s"}|${s}`;
  if (cache.has(key)) return cache.get(key);
  let em;
  const c = context();
  if (c) { c.font = `${bold ? 700 : 400} 100px ${mono ? MONO : SANS}`; em = c.measureText(s).width / 100; }
  if (!Number.isFinite(em) || em <= 0) em = s.length * (mono ? 0.6 : bold ? 0.6 : 0.55);
  cache.set(key, em);
  return em;
}
